<template>
  <Card :title="$t('global.quick-add-db-and-user')">
    <ErrorState v-if="siteStatus.isErrored" />
    <LoadingState v-if="siteStatus.isLoading || siteStatus.isUninitialized" />
    <CardActionContent v-else-if="siteStatus.isLoaded" :buttons="quickAddButton" />
  </Card>
</template>

<script>
import Card from "@/components/display/Card";
import CardActionContent from "@/components/display/card-sub-components/CardActionContent";
import DbAddWithUserModal from "@/components/smart/modals/DbAddWithUser";
import ErrorState from "@/components/display/ErrorState";
import LoadingState from "@/components/display/LoadingState";
import NavLink from "@/classes/NavLink";
import Status from "@/classes/Status";
import store from "@/store";

export default {
  name: "DbAddWithUser",
  components: {
    Card,
    CardActionContent,
    ErrorState,
    LoadingState,
  },
  props: {
    site: Object,
    siteStatus: Status,
  },
  setup(props, { root }) {
    // open new tab for phpmyadmin
    const quickAddDbAndUser = () => {
      store.dispatch("modals/open", {
        template: DbAddWithUserModal,
        data: {
          site: props.site,
        },
      });
    };

    // phpmyadmin card's action buttons
    const quickAddButton = [
      new NavLink(root.$t("global.add-db-and-user"), null, quickAddDbAndUser, false, "primary"),
    ];

    return {
      quickAddButton,
    };
  },
};
</script>
